import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { DE } from '../Languages/DE';
import { EN } from '../Languages/EN';
import { Link, useHistory, useLocation } from "react-router-dom";
import { string } from 'prop-types';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import { $crud } from '../helper/CrudFactory';
import { callAPI } from '../helper/apiUtils';
import { SET_USER, SET_USER_LOGIN_TOKEN, store } from '../store';
import { $user } from '../helper/UserFactory';
import { useDispatch } from 'react-redux';
import "./SecurityPINMain.css";


function SecurityPINMain(props) {
    const [otp, setOtp] = useState('')
    const [cotp, setCOtp] = useState('')
    const [isGerms, setIsGerm] = useState(true);
    const history = useHistory();
    const [isInvalid, setIsInvalid] = useState(false);
    const [invalidMsg, setInvalidMsg] = useState("");
    const user = $user.get();
    const dispatch = useDispatch();

    let state = history.location.state
    const [loading, setLoading] = useState(false);

    const handleChange = (otp) => {
        setInvalidMsg('');
        setIsInvalid(false);
        setOtp(otp)
    };
    const handleChangeC = (otp) => {
        setInvalidMsg('');
        setIsInvalid(false);
        setCOtp(otp)
    };
    useEffect(() => {
        let registerLang = localStorage.getItem("regiLang");
        if (registerLang) {
            setIsGerm(registerLang == 2 ? true : false);
        }
    }, [])
    const _handleConfirm = async () => {
        if (state.isResetPIN) {
            try {
                setLoading(true)
                const data = await $crud.post("/auth/verifyPin", { username: user.username, userPin: otp, language: isGerms ? "de" : "en" });
                if (data.status) {
                    setLoading(false)
                    const datax = await $crud.post("/auth/resetPin", { userPin: cotp });
                    if (datax.status) {
                        $crud.notify({
                            type: datax.status ? "success" : "error",
                            message: datax.message,
                        });
                        history.goBack()
                    }
                }
                else {
                    setLoading(false)
                    $crud.notify({
                        type: data.status ? "success" : "error",
                        message: isGerms ? DE.not_valid_pin : EN.not_valid_pin,
                    });
                }
            } catch (err) {
                setLoading(false)
            }
        }
        else if (state.isResetPassword) {
            try {
                setLoading(true)
                const data = await $crud.post("/auth/verifyPin", { username: user.username, userPin: otp, language: isGerms ? "de" : "en" }, { notify: false });
                if (data.status) {
                    const datax = await $crud.post("/user/resetPassword", {
                        password: state.password,
                        confirmPassword: state.confirmPassword
                    });
                    setLoading(false)
                    if (datax.status) {
                        $crud.get("/user/logout", {});
                        await $user.logout();
                        dispatch({ type: SET_USER_LOGIN_TOKEN, status: null })
                        history.replace('/')
                    }
                }
                else {
                    setLoading(false)
                    $crud.notify({
                        type: "error",
                        message: isGerms ? DE.not_valid_pin : EN.not_valid_pin,
                    });
                }
            } catch (err) {
                setLoading(false)
            }
        }
        else if (state.isResetUsername) {
            try {
                setLoading(true)
                const data = await $crud.post("/auth/verifyPin", { username: user.username, userPin: otp, language: isGerms ? "de" : "en" }, { notify: false });
                if (data.status) {
                    const datax = await $crud.post("/auth/resetUserName", {
                        userName: state.username
                    });
                    setLoading(false)
                    if (datax.status) {
                        $crud.get("/user/logout", {});
                        await $user.logout();
                        dispatch({ type: SET_USER_LOGIN_TOKEN, status: null })
                        history.replace('/')
                    }
                }
                else {
                    setLoading(false)
                    $crud.notify({
                        type: "error",
                        message: isGerms ? DE.not_valid_pin : EN.not_valid_pin,
                    });
                }
            } catch (err) {
                setLoading(false)
            }
        }
    }
    const pageWrapStyle = {
        minHeight: "93vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingTop: "6vh",
        paddingLeft: 16,
        paddingRight: 16,
        boxSizing: "border-box",
    };

    const cardStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        maxWidth: 420,
        backgroundColor: "#ffffff",
        border: "1px solid #ececec",
        borderRadius: 14,
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.06)",
        padding: "20px 24px 32px",
        boxSizing: "border-box",
    };

    const headerRowStyle = {
        display: "flex",
        alignItems: "center",
        gap: 8,
        paddingBottom: 16,
        borderBottom: "1px solid #f2f2f2",
        marginBottom: 24,
    };

    const backBtnStyle = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--kjuup-accent)",
        lineHeight: 1,
    };

    const titleStyle = {
        margin: 0,
        fontSize: 16,
        fontWeight: 600,
        color: "#303030",
    };

    const helperTextStyle = {
        margin: "0 0 24px",
        fontSize: "var(--kjuup-type-body)",
        color: "#6b6b6b",
        textAlign: "center",
    };

    const otpInputStyle = {
        height: 52,
        width: 44,
        margin: "0 6px",
        fontSize: 20,
        fontWeight: 600,
        color: "#303030",
        border: "1.5px solid #d9d9d9",
        borderRadius: 10,
        outline: "none",
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    };

    const otpFocusStyle = {
        borderColor: "var(--kjuup-accent)",
        boxShadow: "0 0 0 3px rgba(var(--kjuup-accent-rgb), 0.15)",
    };

    const otpContainerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const sectionLabelStyle = {
        margin: "0 0 12px",
        fontSize: 14,
        fontWeight: 500,
        color: "#303030",
        textAlign: "center",
    };

    return (
        (state?.isPassword || state?.isResetPassword || state?.isResetUsername) ?
            <div style={pageWrapStyle}>
                <div className="pin-reset-card" style={cardStyle}>
                    <div style={headerRowStyle}>
                        <a className="pointer" style={backBtnStyle} onClick={() => history.goBack()}>
                            <span className="material-symbols-outlined material-arrow-left">
                                keyboard_arrow_left
                            </span>
                        </a>
                        <p style={titleStyle}>{isGerms ? state?.isResetUsername ? DE.change_username : DE.reset_password : state?.isResetUsername ? EN.change_username : EN.reset_password}</p>
                    </div>

                    <p className="security-pin__helper" style={helperTextStyle}>{isGerms ? DE.pin_to_confirm : EN.pin_to_confirm}</p>

                    <OtpInput
                        isInputNum
                        value={otp}
                        onChange={handleChange}
                        numInputs={6}
                        separator={<span className="security-pin-main__separator" />}
                        containerStyle={otpContainerStyle}
                        inputStyle={otpInputStyle}
                        focusStyle={otpFocusStyle}
                    />

                    {isInvalid && (
                        <p className="text-center small text-danger security-pin-main__error">{invalidMsg}</p>
                    )}

                    <div className="security-pin-main__actions">
                        <button
                            type="button"
                            disabled={loading || otp.length !== 6}
                            className="kj-btn kj-btn--outline kj-btn--block"
                            onClick={_handleConfirm}
                        >
                            {loading ? (
                                <LoadingDots />
                            ) : isGerms ? (
                                DE.confirm
                            ) : (
                                EN.confirm
                            )}
                        </button>
                    </div>
                </div>
            </div>
            :
            state?.isResetPIN ?
                <div style={pageWrapStyle}>
                    <div className="pin-reset-card" style={cardStyle}>
                        <div style={headerRowStyle}>
                            <a className="pointer" style={backBtnStyle} onClick={() => history.goBack()}>
                                <span className="material-symbols-outlined material-arrow-left">
                                    keyboard_arrow_left
                                </span>
                            </a>
                            <p style={titleStyle}>{isGerms ? DE.resetPIN : EN.resetPIN}</p>
                        </div>

                        <p style={sectionLabelStyle}>{isGerms ? DE.enter_current_pin : EN.enter_current_pin}</p>
                        <OtpInput
                            value={otp}
                            onChange={handleChange}
                            numInputs={6}
                            isInputNum
                            separator={<span className="security-pin-main__separator" />}
                            containerStyle={otpContainerStyle}
                            inputStyle={otpInputStyle}
                            focusStyle={otpFocusStyle}
                        />

                        <p style={{ ...sectionLabelStyle, marginTop: 28 }}>{isGerms ? DE.enter_new : EN.enter_new}</p>
                        <OtpInput
                            value={cotp}
                            onChange={handleChangeC}
                            numInputs={6}
                            isInputNum
                            separator={<span className="security-pin-main__separator" />}
                            containerStyle={otpContainerStyle}
                            inputStyle={otpInputStyle}
                            focusStyle={otpFocusStyle}
                        />

                        {isInvalid && (
                            <p className="text-center small text-danger security-pin-main__error">{invalidMsg}</p>
                        )}

                        <div className="security-pin-main__actions">
                            <button
                                type="button"
                                disabled={loading || cotp.length !== 6}
                                className="kj-btn kj-btn--outline kj-btn--block"
                                onClick={_handleConfirm}
                            >
                                {loading ? (
                                    <LoadingDots />
                                ) : isGerms ? (
                                    DE.confirm
                                ) : (
                                    EN.confirm
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                :
                <></>
    )
}

export default SecurityPINMain